import { Period, PeriodMonthJanuary, PeriodTypeYear } from "@dto/period";
import { TW_FilterEditorPeriodInput } from "@utils/twClasses";
import { memo, useEffect, useState } from "react";
import { PeriodEditionFormProps } from "./PeriodCell";
import { cn } from "@comps/lib/utils";

export const PeriodYearEditionForm = memo(function PeriodYearEditionForm({ field, value, updatePeriod, searchValue, setSearchValue, searchInputRef, displaySearch = true, hasValidation = true, disabled = false, className }: PeriodEditionFormProps) {

    const intRegex = /^-?\d*$/;
    const [text, setText] = useState<string | null>(null);

    useEffect(() => {
        if (value) {
            const period = Period.fromObject(value);
            setText(period?.year()?.toString() || "");
        } else {
            setText(null);
        }
    }, [value]);

    const updateLocalValue = (value: any) => {
        setText(value?.year()?.toString() || "");
        updatePeriod(value);
    }

    const textToValue = (text: string | null): any => {
        if (!text || text.length === 0) {
            return null;
        }
        const year = parseInt(text);
        return Period.newPeriod(year, PeriodMonthJanuary, 1, PeriodTypeYear);
    }

    function isTextValid(value: string | null) {
        if (value === null || value.length === 0) {
            return true;
        }
        return intRegex.test(value);
    }


    function validate() {
        if (isTextValid(text)) {
            updateLocalValue(textToValue(text));
        }
    }

    // Without a validation button (filter editor, period selector) leaving the
    // input applies the year typed, as Enter does; unchanged text is ignored.
    function onBlur() {
        if (hasValidation || disabled) {
            return;
        }
        const currentYear = value ? (Period.fromObject(value)?.year()?.toString() ?? "") : "";
        if ((text ?? "") === currentYear) {
            return;
        }
        validate();
    }

    function onEnterKeyPressEditing(event: React.KeyboardEvent) {
        if (disabled) {
            return;
        }
        switch (event.key) {
            case "Enter":
                event.preventDefault();
                event.stopPropagation();
                validate();
                
                break;
            default:
                return;
        }
    }

    function onTextChange(event: React.ChangeEvent<HTMLInputElement>) {
        let value = event.target.value;
        if (isTextValid(value)) {
            setText(value);
        } else {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    return (
        <input
            className={cn(TW_FilterEditorPeriodInput + (disabled ? " cursor-not-allowed opacity-60" : " cursor-pointer"), className)}
            type="text"
            value={text ?? ""}
            onChange={onTextChange}
            onKeyDown={onEnterKeyPressEditing}
            onBlur={onBlur}
            autoFocus={true}
            disabled={disabled}
        />
    )
}, (prevProps, nextProps) => {
    return prevProps.field === nextProps.field && prevProps.value === nextProps.value && prevProps.searchValue === nextProps.searchValue && prevProps.searchInputRef === nextProps.searchInputRef && prevProps.disabled === nextProps.disabled;
});